import './_image-zoom-button.scss';

export default () => {};
